import apiRequest from './apiRequest';

export type AssetType =
  | 'MASCOT_JOB'
  | 'MOGEN_JOB'
  | 'MEDIA_IMAGE'
  | 'MEDIA_VIDEO'
  | 'SCENE';

export type AssetListItem = {
  assetID: string;
  assetName: string;
  assetType: AssetType;
  createdAt: string;
  createdBy: string;
  createdByUser: string;
  groupID?: string;
  groupName?: string;
  isBookmarked?: boolean;
  isDeleted?: boolean;
  lastUpdatedAt: string;
  thumbnailURL: string | null;
};

export type AssetListResponse = {
  assets: AssetListItem[];
  nextToken?: string;
};

export type GetAssetsParams = {
  assetType?: AssetType | AssetType[];
  /** Filter results by authored-by user ID. */
  createdByUser?: string;
  /** Filter by last modified time range (`start;end` ISO timestamps). */
  lastUpdatedAt?: string;
  limit?: number;
  nextToken?: string;
  sortAscending?: boolean;
  /** User requesting assets; required for bookmark state on results. */
  requestedByUser?: string;
  /** When true, returns deleted assets (trash view). */
  isDeleted?: boolean;
  /** When true, returns bookmarked assets only (bookmarks view). */
  isBookmarked?: boolean;
};

export default async function getAssets(
  apiKey: string,
  params: GetAssetsParams = {},
  signal?: AbortSignal,
) {
  const urlParams = new URLSearchParams();

  if (params.assetType) {
    const assetTypes = Array.isArray(params.assetType)
      ? params.assetType
      : [params.assetType];

    for (const assetType of assetTypes) {
      urlParams.append('assetType', assetType);
    }
  }
  if (params.createdByUser) {
    urlParams.set('createdByUser', params.createdByUser);
  }
  if (params.lastUpdatedAt) {
    urlParams.set('lastUpdatedAt', params.lastUpdatedAt);
  }
  if (params.limit != null) {
    urlParams.set('limit', params.limit.toString());
  }
  if (params.nextToken) {
    urlParams.set('nextToken', params.nextToken);
  }
  if (params.sortAscending != null) {
    urlParams.set('sortAscending', params.sortAscending.toString());
  }
  if (params.requestedByUser) {
    urlParams.set('requestedByUser', params.requestedByUser);
  }
  if (params.isDeleted != null) {
    urlParams.set('isDeleted', params.isDeleted.toString());
  }
  if (params.isBookmarked != null) {
    urlParams.set('isBookmarked', params.isBookmarked.toString());
  }

  const query = urlParams.toString();

  return apiRequest<AssetListResponse>(
    'external-mogen',
    `/assets${query ? `?${query}` : ''}`,
    {
      method: 'GET',
      headers: {
        'x-api-key': apiKey,
      },
    },
    signal,
  );
}
